// Configuración de la empresa desde variables de entorno
export const companyConfig = {
  name: process.env.REACT_APP_COMPANY_NAME || 'Plásticos Polcen',
  legalName: process.env.REACT_APP_COMPANY_LEGAL_NAME || 'Plásticos Polcen',
  cuit: process.env.REACT_APP_COMPANY_CUIT || '',
  foundationYear: process.env.REACT_APP_COMPANY_FOUNDATION_YEAR || '1975',
  phone: process.env.REACT_APP_COMPANY_PHONE || '(264) 411-4422',
  whatsapp: process.env.REACT_APP_COMPANY_WHATSAPP || process.env.REACT_APP_COMPANY_PHONE || '(264) 411-4422',
  email: process.env.REACT_APP_COMPANY_EMAIL || 'plasticospolcen@gmail.com',
  address: process.env.REACT_APP_COMPANY_ADDRESS || 'Santiago de Liniers 1239, Rivadavia, San Juan, Argentina',
  website: process.env.REACT_APP_COMPANY_WEBSITE || '',
  instagram: process.env.REACT_APP_COMPANY_INSTAGRAM || '',
  hours: process.env.REACT_APP_COMPANY_HOURS || 'Lunes a Viernes de 08:00 a 17:00',
  description: process.env.REACT_APP_COMPANY_DESCRIPTION || 'Especialistas en bolsas de plástico LDPE personalizadas desde 1975',
  product: process.env.REACT_APP_COMPANY_PRODUCT || 'Bolsas de plástico LDPE (Polietileno de Baja Densidad) personalizadas',
  specs: process.env.REACT_APP_COMPANY_SPECS || 'Todos los anchos y largos (máximo 1.20 metros), todos los colores, hasta 200 micrones',
  deliveryTime: process.env.REACT_APP_COMPANY_DELIVERY_TIME || '7 a 15 días',
  minQuantity: process.env.REACT_APP_COMPANY_MIN_QUANTITY || 'Depende del espesor, generalmente más de 1000 unidades',
  googleMapsUrl:
    process.env.REACT_APP_COMPANY_GOOGLE_MAPS_URL ||
    'https://www.google.com/maps/place/Plasticos+Polcen/@0,0,17z/data=!4m6!3m5!1s0x968141a071a7f3e3:0xbba5d1d6898378f1!8m2!3d-31.5153514!4d-68.5718014!16s%2Fg%2F11c71pjn8q?hl=es-419&entry=ttu',
};

// Funciones auxiliares
export const getCompanyTagline = () => {
  return `Desde Año ${companyConfig.foundationYear} en Fabricación de Bolsas de Plástico`;
};

export const getCompanyExperience = () => {
  const currentYear = new Date().getFullYear();
  const foundationYear = parseInt(companyConfig.foundationYear);
  const years = currentYear - foundationYear;
  return `${years}+`;
};

export const getCompanyExperienceDescription = () => {
  const currentYear = new Date().getFullYear();
  const foundationYear = parseInt(companyConfig.foundationYear);
  const years = currentYear - foundationYear;

  if (years >= 40) {
    return `Casi cinco décadas fabricando bolsas de plástico de calidad`;
  } else if (years >= 20) {
    return `Más de dos décadas fabricando bolsas de plástico de calidad`;
  } else if (years >= 10) {
    return `Más de una década fabricando bolsas de plástico de calidad`;
  } else {
    return `${years} años fabricando bolsas de plástico de calidad`;
  }
};
